export function transformCellValue(cellValue, transformationOptions) {
  cellValue = cellValue || ''

  if (transformationOptions.replace_spaces_with) {
    cellValue = cellValue.toString().replace(/\s/g, transformationOptions.replace_spaces_with)
  } else if (transformationOptions.remove_spaces) {
    cellValue = cellValue.toString().replace(/\s/g, '')
  }

  if (transformationOptions.uppercase) {
    cellValue = cellValue.toString().toUpperCase()
  } else if (transformationOptions.lowercase) {
    cellValue = cellValue.toString().toLowerCase()
  }

  return cellValue
}
